export default __webpack_public_path__ + "static/media/photo.ad5154f0.jpg";